import { Button, Drawer } from '@cimpress/react-components';
import { Link } from 'react-router-dom';
import Loading from '../common/Loading';
import DelayScheduleList from './DelayScheduleList';
import ProductLinkList from './ProductLinkList';
import AuthGuard, { readUpdateDelete } from '../Authorisation';
import { UPDATE_PRODUCTION_DELAY } from '../../constants/common';
import { showSnackbar } from '../../redux/actions/snackbarActions';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { getAccountDetails } from '../../services/account';
import { getProductionDelay } from '../../services/productionDelay';

const GuardedButtonLink = ({ productionDelay, permissions, principal }) => (
  <Link to={`/${productionDelay.id}/edit`}>
    <Button
      variant='primary'
      disabled={!permissions.includes(UPDATE_PRODUCTION_DELAY) && productionDelay.createdBy !== principal}
    >
      Edit
    </Button>
  </Link>
);

const ProductionDelayDetailsDrawer = ({ open, onClose, productionDelay, principal }) => {
  const dispatch = useDispatch();
  const [isLoadingAccountDetail, setIsLoadingAccountDetail] = useState(false);
  const [accountDetail, setAccountDetail] = useState({ accountId: '', name: '' });

  useEffect(() => {
    const fetchAccountDetails = async () => {
      try {
        setIsLoadingAccountDetail(true);

        const id = productionDelay.id;
        const productionDelayData = await getProductionDelay({ id });

        setAccountDetail(prev => ({
          ...prev,
          accountId: productionDelayData?.accountId,
        }));

        setIsLoadingAccountDetail(false);

        const accountDetails = await getAccountDetails(productionDelayData?.accountId);

        setAccountDetail(accountDetails);
      } catch (error) {
        dispatch(
          showSnackbar({
            message: 'Failed to fetch Account Detail From Production Delay',
            style: 'danger',
          }),
        );
        setIsLoadingAccountDetail(false);
      }
    };
    fetchAccountDetails();
  }, [productionDelay, dispatch]);

  return (
    <Drawer
      size={0.6}
      show={open}
      onRequestHide={onClose}
      header={`Production Delay for ${productionDelay.name}`}
      closeOnClickOutside={true}
    >
      <div className='flex-row' style={{ justifyContent: 'space-between', marginBottom: '32px', alignItems: 'center' }}>
        <div>
          <div className={'pd-drawer-heading'} style={{ marginBottom: '8px' }}>
            Account ID
          </div>
          {isLoadingAccountDetail ? (
            <Loading style={{ marginLeft: '5px', justifyContent: 'left' }} size={'medium'} />
          ) : (
            <div>
              {accountDetail?.accountId}
              {accountDetail?.name && ` (${accountDetail.name})`}
            </div>
          )}
        </div>
        <div>
          <AuthGuard
            guards={[readUpdateDelete]}
            parameters={{ resourceId: productionDelay.id, principal, loaderSize: 'medium', skipError: true }}
          >
            <GuardedButtonLink productionDelay={productionDelay} principal={principal} />
          </AuthGuard>
        </div>
      </div>
      <DelayScheduleList productionDelay={productionDelay} />
      <ProductLinkList productionDelay={productionDelay} />
    </Drawer>
  );
};

export default ProductionDelayDetailsDrawer;
